module.exports = __webpack_public_path__ + "img/stone9.6a58362e.png";